module.exports = __webpack_public_path__ + "img/11_J_clubs.ba50ddc0.png";